export const PRODUCT_REVIEWS_CLASS = 'js-reviews-wrapper';
export const ENTER_KEY = 'Enter';
export const ENTER_KEY_CODE = 'NumpadEnter';
export const REVIEW_DISPLAY = 'pr-review-display';
export const REVIEW_SNIPPET = 'pr-review-snippet';
export const QUESTION_DISPLAY = 'pr-questiondisplay';
export const SNAPSHOT_TYPE = 'SIMPLE';
export const enum PAGINATION_TYPE {
    DEFAULT = 'DEFAULT',
    VERTICAL = 'VERTICAL'
}
export const REVIEW_COMPONENTS = {
    ReviewDisplay: REVIEW_DISPLAY,
    ReviewSnippet: REVIEW_SNIPPET
};
export const AVERAGE_RATING = 'averageRating';
export const POWER_REVIEWS_SCRIPT = '//ui.powerreviews.com/stable/4.0/ui.js';
export const POWER_REVIEWS_API_LINK = 'https://readservices-b2c.powerreviews.com';
export const TOTAL_NUMBER_OF_STARS = 5;
export const HELPFUL_YES_CLASS = 'pr-helpful-yes';
export const HELPFUL_NO_CLASS = 'pr-helpful-no';
export const FLAG_REVIEW_CLASS = 'pr-rd-flag-review-container';
export const SORT_BY_ID = 'pr-rd-sort-by';
export const MULTI_SELECT_CLASS = 'pr-multiselect';
export const MULTI_SELECT_ITEM_CLASS = 'pr-multiselect-item';
export const MULTI_SELECT_BUTTON_LABEL_CLASS = 'pr-multiselect-button-label';
export const REVIEWS_SEARCH_CLASS = 'pr-rd-search-reviews-input';
export const REVIEWS_SEARCH_BUTTON_CLASS = 'pr-rd-search-reviews-icon-button';
export const ASK_AND_ANSWER_BUTTON_ID = 'pr-question-form-link';
export const ASK_AND_ANSWER_FORM_ID = 'pr-question-form-content';
export const ASK_AND_ANSWER_SEARCH_CLASS = 'pr-qa-display-searchbar';
export const ASK_AND_ANSWER_SEARCH_BUTTON_CLASS = 'pr-qa-search-btn';
export const ASK_AND_ANSWER_SORT_BY_ID = 'pr-qa-sort-by';
export const ASK_AND_ANSWER_SHOW_MORE_CLASS = 'pr-qa-display-show-more-questions';
export const DEFAULT_AVERAGE_RATING = 0;
export const DEFAULT_REVIEW_COUNT = 0;
export const DEFAULT_ANSWERED_QUESTIONS = 0;
export const DEFAULT_REVIEW_TITLE = 'Reviews';
export const REVIEW_SNAPSHOT_ID = 'pr-review-snapshot';

export enum ReviewClickEventSelectors {
    WRITE_REVIEW = '.pr-snippet-write-review-link',
    REVIEW_HELPFUL_YES = '#pr-review-display .pr-helpful-yes',
    REVIEW_HELPFUL_NO = '#pr-review-display .pr-helpful-no',
    FLAG_REVIEW = '.pr-rd-flag-review-container',
    MULTI_SELECT = '.pr-multiselect-item',
    REVIEW_SEARCH = '.pr-rd-search-reviews-icon-button',
    ASK_AND_ANSWER_BUTTON = '#pr-question-form-link',
    ASK_AND_ANSWER_SEARCH = '.pr-qa-search-btn',
    ASK_AND_ANSWER_HELPFUL_YES = '#pr-questiondisplay .pr-helpful-yes',
    ASK_AND_ANSWER_HELPFUL_NO = '#pr-questiondisplay .pr-helpful-no',
    ASK_AND_ANSWER_SHOW_MORE = '.pr-qa-display-show-more-questions'
}
